import { BackendModel, BackendService } from '../../core/backend.service';
import { OperationalParametric } from '../../cliente/operationalParametric.model';

export class Proveedor extends BackendModel {

  static path = '/productos/proveedores/';

  id: number;
  razonSocial: string;
  cuit: string;
  observaciones: string;
  situacionIva: OperationalParametric;
  pais:string;
  codigoPlataforma:string;
  impuestoCaba:string;
  impuestoBsAs:string;

  constructor(protected backendService: BackendService, model?: Proveedor) {
    super(backendService, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/proveedor/proveedor.model.ts